// Corporate-quarterly — variant. Renders /templates/corporate-quarterly.html
// (editorial corporate-anniversary "10 years" report-style template,
// paper + ink + gold, Cormorant Garamond display + Inter sans + JetBrains
// Mono captions) inside a full-bleed iframe. The HTML's customizer reads
// names(=company)/date/time/venue/address from the query string and
// substitutes the baked-in mock tokens. dress_code / rsvp_deadline /
// speakers are also honoured by the HTML but are not yet exposed on the
// Template type (no payload.custom plumbing) — follow-up needed.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/corporate-quarterly.html";

export function CorporateQuarterlyStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();

  // Catalog "names" carries "Company · 10" — split into company / years.
  // The HTML customizer reads the company from `names` (universal editor
  // field); `company` + `years` are kept for backward compatibility.
  if (t.names) {
    const [company, years] = t.names.split(/\s*[·•]\s*/);
    if (company) {
      params.set("names", company.trim());
      params.set("company", company.trim());
    }
    const yr = years?.match(/\d+/)?.[0];
    if (yr) params.set("years", yr);
  }
  if (t.date) {
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (ctx.slug) params.set("slug", ctx.slug);
  params.set("v", "2");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;
  return (
    <iframe
      src={src}
      title={t.names || "Corporate Quarterly"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#F4F1EA",
      }}
    />
  );
}
